"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "@/components/image";
import Modal from "@/components/modal";
import { Button } from "@/components/ui/button";
import { Link } from "@/i18n/routing";
import { CalendarIcon, MailIcon } from "lucide-react";
import * as motion from "motion/react-client";
import { useLocale, useTranslations } from "next-intl";
import ContactForm from "./contact-form";
const Hero = () => {
  const $ = _c(77);
  const t = useTranslations("Home");
  const locale = useLocale();
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_20%_40%,hsl(var(--accent)/0.08),transparent_60%)]" />;
    t1 = <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_80%_60%,hsl(var(--accent)/0.04),transparent_50%)]" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="absolute inset-0 opacity-[0.03]" style={{
      backgroundImage: "linear-gradient(hsl(var(--foreground) / 0.15) 1px, transparent 1px),\n                            linear-gradient(90deg, hsl(var(--foreground) / 0.15) 1px, transparent 1px)",
      backgroundSize: "60px 60px"
    }} />;
    t3 = <div className="absolute bottom-0 left-0 right-0 h-32 bg-linear-to-t from-background to-transparent" />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      translateX: -30,
      opacity: 0
    };
    t5 = {
      translateX: 0,
      opacity: 1
    };
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      duration: 0.8,
      ease: [0.25, 0.1, 0.25, 1]
    };
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  let t8;
  let t9;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      opacity: 0,
      translateY: 10
    };
    t8 = {
      opacity: 1,
      translateY: 0
    };
    t9 = {
      delay: 0.3,
      duration: 0.6,
      ease: "easeOut"
    };
    $[7] = t7;
    $[8] = t8;
    $[9] = t9;
  } else {
    t7 = $[7];
    t8 = $[8];
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <span className="relative flex size-2"><span className="absolute inline-flex size-full animate-ping rounded-full bg-green-400 opacity-75" /><span className="relative inline-flex size-2 rounded-full bg-green-500" /></span>;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  const t11 = locale === "en" ? "Available for new projects" : "Disponibile per nuovi progetti";
  let t12;
  if ($[11] !== t11) {
    t12 = <motion.div initial={t7} animate={t8} transition={t9} className="flex items-center gap-2.5 text-sm font-mono text-muted-foreground justify-center md:justify-start">{t10}{t11}</motion.div>;
    $[11] = t11;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  let t14;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      opacity: 0,
      translateY: 20
    };
    t14 = {
      opacity: 1,
      translateY: 0
    };
    $[13] = t13;
    $[14] = t14;
  } else {
    t13 = $[13];
    t14 = $[14];
  }
  let t15;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = {
      delay: 0.15,
      duration: 0.7,
      ease: [0.25, 0.1, 0.25, 1]
    };
    $[15] = t15;
  } else {
    t15 = $[15];
  }
  let t16;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <motion.span initial={{
      rotate: 0
    }} animate={{
      rotate: [0, 20, -10, 20, 0]
    }} transition={{
      duration: 1.2,
      delay: 0.8,
      ease: "easeInOut"
    }} className="inline-block origin-[70%_70%]">👋</motion.span>;
    $[16] = t16;
  } else {
    t16 = $[16];
  }
  const t17 = locale === "en" ? "Hey, I'm " : "Ciao, sono ";
  let t18;
  let t19;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = {
      opacity: 0,
      scale: 0.9
    };
    t19 = {
      opacity: 1,
      scale: 1
    };
    $[17] = t18;
    $[18] = t19;
  } else {
    t18 = $[17];
    t19 = $[18];
  }
  let t20;
  let t21;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = {
      delay: 0.5,
      duration: 0.6,
      ease: [0.25, 0.1, 0.25, 1]
    };
    t21 = <span className="text-[hsl(var(--accent))]">Alain</span>;
    $[19] = t20;
    $[20] = t21;
  } else {
    t20 = $[19];
    t21 = $[20];
  }
  let t22;
  let t23;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = {
      scaleX: 0
    };
    t23 = {
      scaleX: 1
    };
    $[21] = t22;
    $[22] = t23;
  } else {
    t22 = $[21];
    t23 = $[22];
  }
  let t24;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <motion.span className="relative inline-block" initial={t18} animate={t19} transition={t20}>{t21}<motion.span className="absolute -bottom-1 left-0 right-0 h-0.75 rounded-full bg-[hsl(var(--accent))]" initial={t22} animate={t23} transition={{
        delay: 0.9,
        duration: 0.5,
        ease: [0.25, 0.1, 0.25, 1]
      }} style={{
        transformOrigin: "left"
      }} /></motion.span>;
    $[23] = t24;
  } else {
    t24 = $[23];
  }
  let t25;
  if ($[24] !== t17) {
    t25 = <motion.h1 initial={t13} animate={t14} transition={t15} className="text-5xl sm:text-6xl md:text-7xl font-bold tracking-tight leading-[1.05] font-display">{t16}{" "}{t17}{t24}!</motion.h1>;
    $[24] = t17;
    $[25] = t25;
  } else {
    t25 = $[25];
  }
  let t26;
  let t27;
  let t28;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = {
      opacity: 0,
      translateY: 15
    };
    t27 = {
      opacity: 1,
      translateY: 0
    };
    t28 = {
      delay: 0.4,
      duration: 0.7,
      ease: "easeOut"
    };
    $[26] = t26;
    $[27] = t27;
    $[28] = t28;
  } else {
    t26 = $[26];
    t27 = $[27];
    t28 = $[28];
  }
  const t29 = locale === "en" ? "Freelance full-stack developer based in Italy. I build web and mobile apps with modern technologies, focusing on clean code and great user experiences." : "Sviluppatore full-stack freelance con base in Italia. Sviluppo app web e mobile con tecnologie moderne, con focus su codice pulito e grande esperienza utente.";
  let t30;
  if ($[29] !== t29) {
    t30 = <motion.p initial={t26} animate={t27} transition={t28} className="text-muted-foreground text-lg md:text-xl leading-relaxed max-w-xl mx-auto md:mx-0">{t29}</motion.p>;
    $[29] = t29;
    $[30] = t30;
  } else {
    t30 = $[30];
  }
  let t31;
  if ($[31] !== t12 || $[32] !== t25 || $[33] !== t30) {
    t31 = <div className="flex flex-col gap-4">{t12}{t25}{t30}</div>;
    $[31] = t12;
    $[32] = t25;
    $[33] = t30;
    $[34] = t31;
  } else {
    t31 = $[34];
  }
  let t32;
  let t33;
  let t34;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = {
      translateY: 15,
      opacity: 0
    };
    t33 = {
      translateY: 0,
      opacity: 1
    };
    t34 = {
      delay: 0.6,
      duration: 0.6,
      ease: "easeOut"
    };
    $[35] = t32;
    $[36] = t33;
    $[37] = t34;
  } else {
    t32 = $[35];
    t33 = $[36];
    t34 = $[37];
  }
  let t35;
  let t36;
  let t37;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = {
      scale: 1.03
    };
    t36 = {
      scale: 0.97
    };
    t37 = {
      type: "spring",
      stiffness: 400,
      damping: 17
    };
    $[38] = t35;
    $[39] = t36;
    $[40] = t37;
  } else {
    t35 = $[38];
    t36 = $[39];
    t37 = $[40];
  }
  let t38;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t38 = <CalendarIcon className="size-4" />;
    $[41] = t38;
  } else {
    t38 = $[41];
  }
  let t39;
  if ($[42] !== t) {
    t39 = t("buttons.bookACall");
    $[42] = t;
    $[43] = t39;
  } else {
    t39 = $[43];
  }
  let t40;
  if ($[44] !== t39) {
    t40 = <Link href="https://calendly.com/alaindifabio/discovery-call" target="_blank"><motion.div whileHover={t35} whileTap={t36} transition={t37}><Button type="button" size="lg" className="h-12 px-6 text-sm font-semibold shadow-lg shadow-[hsl(var(--accent))]/10">{t38}{t39}</Button></motion.div></Link>;
    $[44] = t39;
    $[45] = t40;
  } else {
    t40 = $[45];
  }
  let t41;
  if ($[46] !== t) {
    t41 = t("sections.contactForm.title");
    $[46] = t;
    $[47] = t41;
  } else {
    t41 = $[47];
  }
  let t42;
  if ($[48] !== t) {
    t42 = t("sections.contactForm.description");
    $[48] = t;
    $[49] = t42;
  } else {
    t42 = $[49];
  }
  let t43;
  let t44;
  let t45;
  if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
    t43 = {
      scale: 1.03
    };
    t44 = {
      scale: 0.97
    };
    t45 = {
      type: "spring",
      stiffness: 400,
      damping: 17
    };
    $[50] = t43;
    $[51] = t44;
    $[52] = t45;
  } else {
    t43 = $[50];
    t44 = $[51];
    t45 = $[52];
  }
  let t46;
  if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
    t46 = <MailIcon className="size-4" />;
    $[53] = t46;
  } else {
    t46 = $[53];
  }
  let t47;
  if ($[54] !== t) {
    t47 = t("buttons.getInTouch");
    $[54] = t;
    $[55] = t47;
  } else {
    t47 = $[55];
  }
  let t48;
  if ($[56] !== t47) {
    t48 = <motion.div whileHover={t43} whileTap={t44} transition={t45}><Button type="button" variant="outline" size="lg" className="h-12 px-6 text-sm font-semibold">{t46}{t47}</Button></motion.div>;
    $[56] = t47;
    $[57] = t48;
  } else {
    t48 = $[57];
  }
  let t49;
  if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
    t49 = <ContactForm />;
    $[58] = t49;
  } else {
    t49 = $[58];
  }
  let t50;
  if ($[59] !== t41 || $[60] !== t42 || $[61] !== t48) {
    t50 = <Modal title={t41} description={t42} trigger={t48}>{t49}</Modal>;
    $[59] = t41;
    $[60] = t42;
    $[61] = t48;
    $[62] = t50;
  } else {
    t50 = $[62];
  }
  let t51;
  if ($[63] !== t40 || $[64] !== t50) {
    t51 = <motion.div initial={t32} animate={t33} transition={t34} className="flex flex-wrap items-center gap-4 justify-center md:justify-start">{t40}{t50}</motion.div>;
    $[63] = t40;
    $[64] = t50;
    $[65] = t51;
  } else {
    t51 = $[65];
  }
  let t52;
  if ($[66] !== t31 || $[67] !== t51) {
    t52 = <motion.div initial={t4} animate={t5} transition={t6} className="flex flex-col gap-8 flex-1 text-center md:text-left">{t31}{t51}</motion.div>;
    $[66] = t31;
    $[67] = t51;
    $[68] = t52;
  } else {
    t52 = $[68];
  }
  let t53;
  let t54;
  if ($[69] === Symbol.for("react.memo_cache_sentinel")) {
    t53 = {
      scale: 0.8,
      opacity: 0
    };
    t54 = {
      scale: 1,
      opacity: 1
    };
    $[69] = t53;
    $[70] = t54;
  } else {
    t53 = $[69];
    t54 = $[70];
  }
  let t55;
  if ($[71] === Symbol.for("react.memo_cache_sentinel")) {
    t55 = {
      duration: 0.8,
      delay: 0.2,
      ease: [0.25, 0.1, 0.25, 1]
    };
    $[71] = t55;
  } else {
    t55 = $[71];
  }
  let t56;
  if ($[72] === Symbol.for("react.memo_cache_sentinel")) {
    t56 = <motion.div className="absolute -inset-6 rounded-full bg-[hsl(var(--accent))]/8 blur-3xl" animate={{
      scale: [1, 1.15, 1],
      opacity: [0.5, 0.8, 0.5]
    }} transition={{
      duration: 5,
      repeat: Infinity,
      ease: "easeInOut"
    }} />;
    $[72] = t56;
  } else {
    t56 = $[72];
  }
  let t57;
  if ($[73] === Symbol.for("react.memo_cache_sentinel")) {
    t57 = <motion.div className="absolute -inset-1 rounded-full bg-linear-to-br from-[hsl(var(--accent))]/30 via-transparent to-[hsl(var(--accent))]/10" animate={{
      rotate: [0, 360]
    }} transition={{
      duration: 20,
      repeat: Infinity,
      ease: "linear"
    }} />;
    $[73] = t57;
  } else {
    t57 = $[73];
  }
  let t58;
  if ($[74] === Symbol.for("react.memo_cache_sentinel")) {
    t58 = <motion.div initial={t53} animate={t54} transition={t55} className="shrink-0 order-first md:order-last"><div className="relative">{t56}{t57}<motion.div animate={{
          y: [0, -8, 0]
        }} transition={{
          duration: 5,
          repeat: Infinity,
          ease: "easeInOut"
        }}><Image src="/images/profile.png" alt="Alain Di Fabio" width={480} height={540} className="relative size-52 md:size-72 rounded-full object-cover object-top border-2 border-[hsl(var(--accent))]/20 shadow-2xl shadow-black/30" /></motion.div></div></motion.div>;
    $[74] = t58;
  } else {
    t58 = $[74];
  }
  let t59;
  if ($[75] !== t52) {
    t59 = <section className="relative min-h-[85vh] flex items-center overflow-hidden">{t0}{t1}{t2}{t3}<div className="mx-auto max-w-6xl px-6 flex flex-col md:flex-row items-center gap-12 md:gap-20 relative py-20 md:py-0">{t52}{t58}</div></section>;
    $[75] = t52;
    $[76] = t59;
  } else {
    t59 = $[76];
  }
  return t59;
};
export default Hero;